/**
 * Redirect the customer to the cart page after a successful "Add to cart".
 *
 * The theme's product form adds items via AJAX and dispatches a bubbling
 * `cart:update` event (see assets/events.js -> CartAddEvent). By default the
 * customer stays on the product page. Here we send them straight to the cart
 * page so they can review and complete the purchase.
 *
 * Loaded as a module, so this listener is registered only once per page even if
 * the including snippet is rendered multiple times.
 */
document.addEventListener('cart:update', (event) => {
  const data = event && event.detail && event.detail.data;

  // Only react to a successful add coming from the product form.
  if (!data) return;
  if (data.source !== 'product-form-component') return;
  if (data.didError) return;

  const routes = window.Theme && window.Theme.routes;
  const cartUrl = (routes && routes.cart_url) || '/cart';

  window.location.href = cartUrl;
});
